import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CURRENT_USER,
  CURRENT_USER_SUCCESS,
  CURRENT_USER_FAILURE,
  EDIT_PROFILE,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
} from "./actionTypes";

const initialState = {
  user: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const authentication = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        user: action.payload,
        isLoggedIn: true,
      };
      break;
    case LOGOUT_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LOGOUT_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        user: {},
        isLoggedIn: false,
      };
      break;
    case CURRENT_USER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CURRENT_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        user: action.payload.user,
        isLoggedIn: true,
      };
      break;

    case CURRENT_USER_FAILURE:
      state = {
        ...state,
        loading: false,
        user: {},
        isLoggedIn: false,
      };
      break;

    //edit prpogile
    case EDIT_PROFILE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case EDIT_PROFILE_SUCCESS:
      state = {
        ...state,
        loading: false,
        user: action.payload.user,
        isLoggedIn: true,
      };
      break;

    case EDIT_PROFILE_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default authentication;
